module.exports = __webpack_public_path__ + "img/p1-info@2x.aa02de27.jpg";